import publicAxios, { API_URL } from './PublicAxios';

// Busca os dados públicos da página /p/{slug}; não usa token de autenticação.
export const getPublicPageBySlug = (slug) => {
    return publicAxios.get(`/api/public-pages/${slug}`);
};

// Permite usar URLs absolutas ou caminhos retornados pelo backend.
export const resolvePublicAssetUrl = (url) => {
    if (!url) return null;
    if (/^https?:\/\//i.test(url)) return url;
    return `${API_URL}${url.startsWith('/') ? url : `/${url}`}`;
};
